'use strict';
'use client';
import { j as s } from "../../external/react/jsx-runtime.js";
import { useState as d } from "react";
import x from "./AccordionItem.js";
const j = ({
  activeColor: n,
  textColor: r,
  bgColor: i,
  initialOpenItem: m,
  items: a,
  onItemOpen: o
}) => {
  const [c, l] = d(
    m
  ), f = (t, e) => {
    c === t ? l(null) : (l(t), o && o(e));
  };
  return /* @__PURE__ */ s.jsx("div", { className: "flex flex-col gap-2 w-full", children: a.map((t, e) => /* @__PURE__ */ s.jsx(
    x,
    {
      title: t.title,
      content: t.content,
      isActive: c === e,
      activeColor: n,
      textColor: r,
      bgColor: i,
      onClick: () => f(e, t)
    },
    e
  )) });
};
export {
  j as default
};
